import React from 'react';
export const Registered = React.lazy(() => import('./Registered.jsx'));
